<div [formGroup]="parentForm" class="grid">
    <mat-form-field class="full-width">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" />
        @if (parentForm.get("name")?.hasError("required")) {
            <mat-error>Name ist erforderlich</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="full-width">
        <mat-label>URL</mat-label>
        <input matInput formControlName="url" placeholder="https://example.com" />
        @if (parentForm.get("url")?.hasError("pattern")) {
            <mat-error>URL ungültig</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="full-width">
        <mat-label>Beschreibung</mat-label>
        <input matInput formControlName="description" />
        @if (parentForm.get("description")?.hasError("required")) {
            <mat-error>Beschreibung erforderlich</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="full-width">
        <mat-label>Authentifizierung</mat-label>
        <mat-select formControlName="authorization">
            <mat-option value="NoAuthorization">Keine Authentifizierung</mat-option>
            <mat-option value="BasicAuth">BasicAuth</mat-option>
        </mat-select>
    </mat-form-field>
</div>
